export default {
  type: "Project type",
  healthProgram: "Health program",
  careProgram: "Care program",
  nationalHealthProgram: "Public health program",
  progress: "Project progress",
};
